import { API, authHeaders } from "./supabase";
import { displayLanguage } from "./gtranslate";

/* Single source of truth for consent wording/version — backend/consent.py mirrors CONSENT_TEXTS. */
export const CONSENT_VERSION = "2026-10-18";
export const CONSENT_TEXT_TERMS = "I agree to the Terms of Service and Privacy Policy. I consent to the collection, international transfer, and AI processing of my personal data.";
export const CONSENT_TEXT_THIRD_PARTY = "I confirm that I have obtained consent from any third-party recipients (clients, contractors) before submitting their contact details or job site information to DropIt.";

const sha256 = async (s) => Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s)))).map((b) => b.toString(16).padStart(2, "0")).join("");
export const consentKey = async (email) => `dropit_consent:${await sha256(email.trim().toLowerCase())}`;

export const getLocalConsent = async (email) => {
  try { const d = JSON.parse(localStorage.getItem(await consentKey(email)) || "null"); return d && d.version === CONSENT_VERSION && d.terms && d.thirdParty ? d : null; } catch { return null; }
};
export const saveLocalConsent = async (email) => {
  const rec = { version: CONSENT_VERSION, at: new Date().toISOString(), terms: true, thirdParty: true, email: email.trim().toLowerCase() };
  localStorage.setItem(await consentKey(email), JSON.stringify(rec));
  localStorage.setItem("dropit_consent_pending", JSON.stringify(rec));  // posted to the account after sign-in
  return rec;
};

export const postConsent = async ({ source, clientAt }) => {
  const r = await fetch(`${API}/consent`, { method: "POST", headers: { "Content-Type": "application/json", ...(await authHeaders()) },
    body: JSON.stringify({ version: CONSENT_VERSION, terms_accepted: true, third_party_confirmed: true, client_consented_at: clientAt || new Date().toISOString(), source, display_language: displayLanguage().slice(0, 32) }) });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Could not record consent");
  return r.json();
};
export const fetchConsent = async () => {
  const r = await fetch(`${API}/consent`, { headers: await authHeaders() });
  if (!r.ok) throw new Error("consent status unavailable");
  return r.json();
};
